import request from 'superagent'
import { clientFunctions } from 'packs/clients/functions'
import { lockButton, unlockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { addToast } from 'src/toasts'
import { camelize } from 'src/misc'
import { showGoogleMap } from 'src/googleMap'

export default () => {
  clientFunctions()

	// datatable init
  let clientsDatatable = $('#clients-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('clientsIndexPageLength') || 25),
    "processing": true,
    "responsive": true,
    "serverSide": true,
    "ajax": {
      "url": $('#clients-datatable').data('source')
    },
    "columns": [
      { "data": "company_name" },
      { "data": "business_id" },
      { "data": "status" },
      { "data": "contact_person" },
      { "data": "phone" },
      { "data": "email" },
      { "data": "address" },
      { "data": "actions", "orderable": false }
    ],
    initComplete(settings, json) {
      $("#datatable-actions").prependTo('#clients-datatable_wrapper')
      $("#clients-datatable_length").prependTo('#datatable-actions')
      $("#clients-datatable_length").addClass('me-3')
      $("#clients-datatable_filter input").removeClass('form-control-sm')
      $("#clients-datatable_filter input").addClass('datatable-search')
      $('#clients-datatable_filter input').attr("type", 'text')
      $("#clients-datatable_filter input").detach().prependTo('#search-div')
      $('#clients-datatable_wrapper .row:first').remove()
      $("#datatable-actions").removeClass('d-none')

      $('.datatable-search').on('input', function() {
        if ($('#search-div input').val()) {
          $('.clear-button').removeClass('d-none')
        } else {
          $('.clear-button').addClass('d-none')
        }
      })

  	}
  })

  $('#content').on('change', "[name='clients-datatable_length']", function() {
    localStorage.setItem('clientsIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    clientsDatatable.search('').draw()
  })

  $('#content').on('click', '#add_client', function() {
    lockButton('#add_client')
    offcanvasRight.show()
    $.getScript('/clients/new')
  })

  $('#content').on('click', '.show-googlemap', function(event) {
    $(event.target).prop("disabled", true)

    const companyName = $(this).data('company_name')
    const streetName = $(this).data('street_name')
    const postCode = $(this).data('post_code')
    const town = $(this).data('town')
    const country = $(this).data('country')
    const totalAddress = (streetName + ", " + postCode + " " + town).trim()
    if (totalAddress.length > 1) {
      let title = companyName
      showGoogleMap(mainModal, title, [{ address: totalAddress + ', ' + country, title: totalAddress }])
    } else {
      addToast(I18n.t("errors.no_address"), 'alert')
    }

    $(event.target).prop("disabled", false)
  })
}
